export const LIST_PERSONNEL = "LIST_PERSONNEL";
export const GET_ALL_USER = "GET_ALL_USER";
export const SET_ALL_USER = "SET_ALL_USER";
export const LIST_USERS = "LIST_USERS";
export const SET_LIST_USERS = "SET_LIST_USERS";
